module.exports = __webpack_public_path__ + "e0ac833ad28f7d8fb9eb54b99380899c.png";